import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import React from "react";
import { useFaCollapsibleContext } from "../FaCollapsibleContext/FaCollapsibleContext";
import "./faCollapsibleTrigger.scss";

interface IFaCollapsibleTriggerProps extends React.ComponentPropsWithoutRef<typeof Slot> { }

export function FaCollapsibleTrigger(props: IFaCollapsibleTriggerProps) {
    const { disabled, open, setOpen } = useFaCollapsibleContext();

    const handleToggle = () => {
        if (disabled) {
            return;
        }
        setOpen(!open);
    };

    return (
        <Slot
            {...props}
            className={clsx(
                "fa-collapsible-trigger",
                {
                    "fa-collapsible-trigger--disabled": disabled,
                },
                props.className
            )}
            onClick={handleToggle}
        />
    );
}
